import type React from "react";
import styles from "./PulseLoader.module.css";

function PulseLoader({
  className = "",
  color = "",
  colorVar = "primary-color",
  size = 2,
}: {
  className?: string;
  color?: string;
  colorVar?: string;
  size?: number;
}) {
  const pulseColor = color ? color : `var(--${colorVar})`;

  return (
    <div className={`${styles.container} ${className}`}>
      <div
        style={{ "--size": `${size}rem`, "--color": pulseColor } as React.CSSProperties}
        className={styles.pulse}
      />
    </div>
  );
}

export default PulseLoader;
